// frontend/src/components/RequestForm.tsx
import { apiUrl, API_BASE_URL } from '../config/paths';
// Версия: 2.0.0 (улучшена 30.10.2025)
// УЛУЧШЕНИЯ:
// - Используется react-hook-form для валидации
// - Правильная типизация validate
// - Поддержка emailData для автозаполнения
// ИСПРАВЛЕНО 2026-01-13: apiUrl() с двумя аргументами → один аргумент + options в fetch()

import React from 'react';
import { useForm } from 'react-hook-form';

type RequestFormValues = {
  planned_test_date?: string;
  vesselName?: string;
  mmsi?: string;
  ssas_number?: string;
  notes?: string;
};

type Props = {
  emailData?: { shipName?: string; mmsi?: string; rawText?: string };
  onSubmitSuccess?: () => void;
};

export default function RequestForm({ emailData, onSubmitSuccess }: Props) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<RequestFormValues>({
    defaultValues: {
      vesselName: emailData?.shipName ?? '',
      mmsi: emailData?.mmsi ?? '',
      notes: emailData?.rawText ?? '',
    },
  });

  const onSubmit = async (data: RequestFormValues) => {
    try {
      // ИСПРАВЛЕНО: apiUrl() принимает только путь, options идут в fetch()
      const response = await fetch(apiUrl('requests'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        alert('Заявка успешно создана!');
        onSubmitSuccess?.();
      } else {
        alert('Ошибка при создании заявки');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Ошибка соединения');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="form-group">
        <label>
          Дата/время теста
          <input
            type="datetime-local"
            {...register('planned_test_date', {
              validate: (v?: string) => (!!v && v.length > 0) || 'Укажите дату/время',
            })}
          />
        </label>
        {errors.planned_test_date && <p className="error">{errors.planned_test_date.message}</p>}
      </div>

      <div className="form-group">
        <label>
          Название судна
          <input type="text" {...register('vesselName')} />
        </label>
      </div>

      <div className="form-group">
        <label>
          MMSI судна
          <input type="text" {...register('mmsi')} />
        </label>
      </div>

      <div className="form-group">
        <label>
          Номер терминала ССТО (Inmarsat-C / Iridium)
          <input type="text" {...register('ssas_number')} />
        </label>
      </div>

      <div className="form-group">
        <label>
          Примечания
          <textarea {...register('notes')} rows={4} />
        </label>
      </div>

      <button type="submit">Отправить заявку</button>
    </form>
  );
}
